import { ClickAwayListener, useMediaQuery } from "@material-ui/core"
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined"
import React from "react"
import { useState } from "react"
import { LIGHT_GRAY_COLOR } from "../../theme"
import TooltipPersonalizado from "./TooltipPersonalizado"

const IconeTooltip = ({ title, placement, estiloIcone }) => {
	const [tooltipAberto, setTooltipAberto] = useState(false)
	const desktop = useMediaQuery((theme) => theme.breakpoints.up("sm"))

	return (
    <ClickAwayListener onClickAway={() => setTooltipAberto(false)}>
      <TooltipPersonalizado
        open={tooltipAberto}
        onOpen={() => setTooltipAberto(true)}
        onClose={() => desktop && setTooltipAberto(false)}
        onClick={() => !desktop && setTooltipAberto(!tooltipAberto)}
        leaveDelay={0}
        placement={placement ? placement : "bottom"}
        title={title}>
        <InfoOutlinedIcon style={{ 
          color: LIGHT_GRAY_COLOR, 
          display: "flex", 
          height: "20px", 
          width: "20px", 
          ...estiloIcone 
        }} />
      </TooltipPersonalizado>
    </ClickAwayListener>
	)
};

export default IconeTooltip;
